import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { nasaPrecipitationColourMapping } from "../util/colors";
import { legendItemStyle, legendStyle } from "./style";
import { mapDataCloudfrontURL } from "../map/MapConstants";

export const NasaNowcastPrecipitationLegend = ({ customLegendStyle = legendStyle, days }) => {
  const { t } = useTranslation();

  const [fileInfo, setFileInfo] = useState({});

  const imageStoreUrl = `${mapDataCloudfrontURL}nasa_nowcast/cys_nowc_precp_ita_nasagpm_${days}day.json`;
  console.log("imageStoreUrl", imageStoreUrl);

  const timestamp = new Date().getTime();
  const cacheBustedUrl = `${imageStoreUrl}?t=${timestamp}`;

  useEffect(() => {
    const fetchFileInfo = async () => {
      try {
        const response = await fetch(cacheBustedUrl);
        const receivedFileInfo = await response.json();
        setFileInfo(receivedFileInfo);
      } catch (error) {
        console.error("Error fetching file info", error);
      }
    };

    fetchFileInfo();
  }, [cacheBustedUrl]);

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("legend.precipitationNowcast", { days: days })}</b>
      </div>

      {nasaPrecipitationColourMapping.map(([value, color, label]) => (
        <div key={value}>
          <span style={legendItemStyle(color)}></span>
          {label}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          From {fileInfo.from} <br /> Until {fileInfo.to} <br /> Created at {fileInfo.remote_file_modified_on}{" "}
          <br /> Processed at {fileInfo.processed_on}
          <br /> <br />
          {t("riskExposureMapExplained.precipitationNowcast", { days: days })}
        </span>
      </div>
    </div>
  );
};
